
require('./bootstrap');

import Vue from 'vue';
window.Vue = Vue;

import { Inertia } from '@inertiajs/inertia'
import { createInertiaApp, Head, Link } from '@inertiajs/inertia-vue';
import { InertiaProgress } from '@inertiajs/progress';

Vue.component('InertiaHead', Head);
Vue.component('InertiaLink', Link);

Vue.config.productionTip = false;
Vue.mixin({methods: {route: window.route}});
Vue.mixin(require('./mixins/Lang.js'));

require('./helpers');

InertiaProgress.init({
    color: window._themeColor,
});

/**
 * 
 */
import AppHead from '@/shared/AppHead';
import Zone from '@/shared/Zone';

Vue.component('AppHead', AppHead);
Vue.component('Zone', Zone);

/**
 * 
 */
import MainLayout from '@/shared/Layouts/MainLayout';

const el = document.getElementById('app');

createInertiaApp({
    resolve: name => {
        const page = require(`./pages/${name}`).default;
        page.layout = page.layout || MainLayout;
        return page;
    },
    setup( { el, app, props }) {
        new Vue({
            render: h => h(app, props),
        }).$mount(el);
    },
});




Inertia.on('navigate', (event) => {
    console.log(`Navigated to ${event.detail.page.url}`);
    if (window._paq) {
        // Matomo
        window._paq.push(['setReferrerUrl', window.location.href]);
        window._paq.push(['setCustomUrl', event.detail.page.url]);
        window._paq.push(['trackPageView']);
        window._paq.push(['enableLinkTracking']);
    }
});
Inertia.on('success', (event) => {
});
Inertia.on('error', (event) => {
});






// @todo in vue component bauen
document.querySelectorAll('.autocomplete-input').forEach(item => {
    item.setAttribute('autocomplete', 'off');
    item.addEventListener('keyup', function (event) {
        var suggestionsElem = event.target.nextElementSibling;
        if (event.target.value.length > 1) {
            suggestionsElem.classList.add('visible');
        } else {
            suggestionsElem.classList.remove('visible');
        }
//        console.log(suggestionsElem);
//        document.querySelectorAll('.main-menu > li').forEach(sub => sub.classList.remove('active'));
//        document.querySelectorAll('.main-menu .sub-menu').forEach(sub => sub.classList.remove('show'));
//        document.body.classList.remove('offcanvas-backdrop');
    }, false);
});

